const TIER_LABELS: Record<string, string> = {
  DEVELOPMENT: "DEV",
  "gb-nhs-uat": "UAT",
  "gb-nhs-staging": "STAGING",
};

export function getEnvironmentLabel(): string | null {
  const appEnvironment = import.meta.env.APP_ENVIRONMENT;
  return appEnvironment ? TIER_LABELS[appEnvironment] ?? null : null;
}
